import { render, staticRenderFns } from "./MaterialTypePage.vue?vue&type=template&id=f969514c&"
import script from "./MaterialTypePage.vue?vue&type=script&lang=js&"
export * from "./MaterialTypePage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports